import React, { useMemo } from 'react';
import Tippy from '@tippy.js/react';

const TooltipTitleComponent = ({ title, leftPanelSize, count, index }) => {
    const renderTitle = useMemo(() => {
        return (
            <Tippy
                content={title}
                interactiveBorder={10}
                animation='scale'
                theme='light-border'
                trigger='mouseenter'
                placement={index === 0 ? 'auto' : 'top'}
            >
                <div className='text-truncate'>
                    {title}
                </div>
            </Tippy>
        );
    }, [title, leftPanelSize]);

    const titleWithTooltip = useMemo(() => {
        return (
            <div className='tooltip-title-component d-flex'>
                {renderTitle}
                {count && <span className='tooltip-title-component__count'>({count})</span>}
            </div>
        );
    }, [title, leftPanelSize, count]);

    return titleWithTooltip;
};

export default TooltipTitleComponent;
